const API_URL = process.env.REACT_APP_API_URL;

export const getCategorias = async (institucionSlug) => {
  const response = await fetch(`${API_URL}/api/categorias/${institucionSlug}`);
  if (!response.ok) throw new Error('Error al obtener categorías');
  return response.json();
};

export const getSubcategorias = async (categoriaSlug) => {
  const response = await fetch(`${API_URL}/api/categorias/${categoriaSlug}/subcategorias`);
  if (!response.ok) throw new Error('Error al obtener subcategorías');
  return response.json();
};

export const getCategoriaDetalle = async (categoriaSlug) => {
  const response = await fetch(`${API_URL}/api/categorias/${categoriaSlug}/detalle`);
  if (!response.ok) throw new Error('Error al obtener detalle de categoría');
  return response.json();
};

export const getPublicaciones = async (categoriaSlug) => {
  const response = await fetch(`${API_URL}/api/publicaciones/${categoriaSlug}`);
  if (!response.ok) throw new Error('Error al obtener publicaciones');
  return response.json();
};

export const getPublicacion = async (categoriaSlug, publicacionSlug) => {
  const response = await fetch(`${API_URL}/api/publicaciones/${categoriaSlug}/${publicacionSlug}`);
  if (!response.ok) throw new Error('Error al obtener publicación');
  return response.json();
};
